'use strict';

var angularModule = angular.module('t2g.common.data-access.sync', []);

module.exports = angularModule;

angularModule.factory('SyncResource', function($resource, settings) {
  var resourceUrl = settings.apiBase + '/api/v2/sync/:resource/:sync';

  var resource = $resource(
    resourceUrl,
    {},
    {
      insert: { method: 'POST' },
      update: { method: 'PUT' },
      runSync: { method: 'POST' },
      get: { method: 'GET', isArray: false },
      delete: { method: 'delete' },
    },
  );

  return resource;
});

angularModule.factory('SyncDA', function($q, SyncResource) {
  return {
    get: function(resource) {
      return SyncResource.get({ resource: resource }).$promise;
    },
    insert: function(resource, sync) {
      return SyncResource.insert({ resource: resource }, sync).$promise;
    },
    delete: function(resource, syncId) {
      return SyncResource.delete({ resource: resource, sync: syncId }).$promise;
    },
    update: function(resource, syncId, sync) {
      return SyncResource.update({ resource: resource, sync: syncId }, sync).$promise;
    },
    runSync: function(resource, syncId) {
      return SyncResource.runSync({ resource: resource, sync: syncId }, null).$promise.then(
        function(response) {
          return response;
        },
        function(response) {
          return $q.reject(response);
        },
      );
    },
  };
});



// WEBPACK FOOTER //
// ./src/app/common/data-access/sync.js